import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { Euro } from "lucide-react";
import GrilleTarifaireView from "@/features/ventes/components/tarifs/GrilleTarifaireView";

export const Route = createFileRoute("/_app/ventes/tarifs/$id/view")({
  loader: requirePermission(PERMISSIONS.VENTES.TARIFS.VIEW),
  staticData: {
    title: "Détails Grille tarifaire",
    icon: Euro,
    showInBreadcrumb: true,
  },
  component: GrilleTarifaireView,
});
